export default "__VITE_ASSET__52e0a6fd__"